import { TableLoadingSpinner } from '../../../../design/components/LoadingSpinner';
import { isValidSortDirection } from '../../../pages/talent-directory/sort-option';
import { pageSizeOptions } from '../common/constants';
import { GeneralDataGrid } from '../common/GeneralDataGrid';

import type { GlobalSearchJob } from '../../../../data-contract/global-search';
import type { SortOption } from '../../../pages/talent-directory/sort-option';
import type { GridCallbackDetails, GridColDef, GridPaginationModel, GridValidRowModel } from '@mui/x-data-grid-pro';
import type { FunctionComponent } from 'react';

type HeadlineRow = {
    readonly area: 'exact' | 'related';
    readonly title: string;
    readonly type: 'headline';
};

type TableRow = GlobalSearchJob | HeadlineRow;

type JobOpeningsDataGridProps = {
    // eslint-disable-next-line functional/prefer-readonly-type
    readonly columns: GridColDef<GridValidRowModel>[] | GridColDef<TableRow>[];
    readonly isFetching: boolean;
    readonly isPending: boolean;
    readonly noDataMessage: string;
    readonly onPaginationModelChange: (model: GridPaginationModel, details: GridCallbackDetails) => void;
    readonly onRowClick: (value: string) => void;
    readonly onSortOptionsChange: (options: readonly SortOption[]) => void;
    readonly paginationModel: GridPaginationModel;
    readonly rowCount: number;
    readonly rows: readonly TableRow[];
    readonly sortOptions: readonly SortOption[];
};

export const JobOpeningsDataGrid: FunctionComponent<JobOpeningsDataGridProps> = ({
    columns,
    isFetching,
    isPending,
    noDataMessage,
    onPaginationModelChange,
    onRowClick,
    onSortOptionsChange,
    paginationModel,
    rowCount,
    rows,
    sortOptions,
}) => (
    <GeneralDataGrid
        columns={columns}
        disableMultipleColumnsSorting={true}
        disableRowSelectionOnClick={true}
        getRowHeight={() => 'auto'}
        loading={isPending || isFetching}
        localeText={{ noRowsLabel: noDataMessage }}
        pageSizeOptions={pageSizeOptions}
        pagination={true}
        paginationMode="server"
        paginationModel={paginationModel}
        rowCount={rowCount}
        rows={rows}
        slots={{
            loadingOverlay: TableLoadingSpinner,
        }}
        sortModel={sortOptions.map(({ direction, field }) => ({
            field,
            sort: direction,
        }))}
        sx={{
            '& .MuiDataGrid-cell': {
                alignItems: 'baseline',
                py: '8px',
            },
            height: '70vh',
        }}
        onPaginationModelChange={onPaginationModelChange}
        onRowClick={(row) => onRowClick(row.id.toString())}
        onSortModelChange={(sortModel) =>
            onSortOptionsChange(
                sortModel.filter(isValidSortDirection).map(({ field, sort }) => ({ direction: sort, field })),
            )
        }
    />
);
